import React from 'react';
import Midchart from '../Midchart';

const RatiosChartGs = () => {
    return (
        <section className="spot-gold">
        <div className="col-12 spot-gold-chart">
            <Midchart title ="ratios_gp_gold" gs = "Gold/Silver" defaultValue = "Ratios" />       
        </div>
        </section>
    )
}

export default RatiosChartGs;


